/* Original brand artwork; native vendor links remain usable without JavaScript. */
if (!customElements.get('cabane-brand-strip')) {
  customElements.define('cabane-brand-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('.cabane-brands__viewport');
      this.group = this.querySelector('.cabane-brands__group');
      this.toggle = this.querySelector('.cabane-brands__toggle');
      if (!this.viewport || !this.group || !this.toggle) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = Math.max(10, Math.min(50, Number(this.dataset.speed) || 32));
      this.visible = false;
      this.userPaused = false;
      this.hovered = false;
      this.interactingUntil = 0;
      this.position = this.viewport.scrollLeft;
      this.measure = () => { this.cycle = this.group.getBoundingClientRect().width; };
      this.motionChanged = () => {
        this.classList.toggle('is-running', !this.motion.matches);
        this.toggle.hidden = this.motion.matches;
        this.measure();
        this.schedule();
      };
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.setAttribute('aria-label', this.userPaused ? 'Reprendre le défilement des marques' : 'Mettre le défilement des marques en pause');
      }, options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.viewport.addEventListener('pointerdown', () => { this.dragging = true; }, options);
      window.addEventListener('pointerup', () => {
        if (this.dragging) { this.dragging = false; this.interactingUntil = performance.now() + 4000; }
      }, options);
      this.viewport.addEventListener('pointercancel', () => { this.dragging = false; this.interactingUntil = performance.now() + 4000; }, options);
      this.viewport.addEventListener('wheel', () => { this.interactingUntil = performance.now() + 4000; }, { ...options, passive: true });
      this.motion.addEventListener('change', this.motionChanged, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.group);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { rootMargin: '80px' });
      this.intersectionObserver.observe(this);
      this.motionChanged();
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.lastTime = 0;
      if (this.visible && !document.hidden && !this.motion.matches) this.frame = requestAnimationFrame(time => this.tick(time));
    }

    tick(time) {
      const elapsed = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;
      this.lastTime = time;
      const focused = this.viewport.contains(document.activeElement);
      const paused = this.userPaused || this.hovered || this.dragging || focused || time < this.interactingUntil;
      if (!paused && this.cycle > this.viewport.clientWidth) {
        // Retain fractional movement: browsers may round scrollLeft on each frame.
        if (Math.abs(this.viewport.scrollLeft - this.position) > 2) this.position = this.viewport.scrollLeft;
        this.position = (this.position + this.speed * elapsed / 1000) % this.cycle;
        this.viewport.scrollLeft = this.position;
      } else {
        this.position = this.viewport.scrollLeft;
      }
      this.frame = requestAnimationFrame(next => this.tick(next));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.controller = null;
    }
  });
}
